// extracted by mini-css-extract-plugin
export default {"spinner":"Spinner_spinner__LrEle","spin":"Spinner_spin__fHVS-"};